export default "__VITE_ASSET__CYjJCghJ__"